// src/design/passportTokens.js

export const passportColors = {
  textPrimary: '#e2e1ee',
  textSecondary: 'rgba(226, 225, 238, 0.65)',
  textMuted: 'rgba(226, 225, 238, 0.38)',
  surface: '#1e1f25',
  surfaceRaised: '#282a2f',
  warning: '#D37633', // Brand Orange
  cyan: '#00E3FD',    // Brand Cyan
  background: '#0c0e13',
  focus: '#00E3FD',
};

export const passportRadii = {
  small: 8,
  medium: 12,
  large: 16,
};

export const passportLayout = {
  mobileNavHeight: 56,
  compactHeaderHeight: 64,
  desktopHeaderHeight: 72,
};
